import { logError } from "../../../shared/functions/misc";
import { getLogins } from "../shared/functions";
import User from "@phoenixreisen/user";
import Config from "../../../config";
import m from "mithril";
const RouteLink = m.route.Link;
export const View = {
    view() {
        try {
            const linkAgency = "/agentur";
            const linkTraveler = getLogins().length > 0 ? "/kunde/letzte-anmeldungen" : "/kunde";
            return [
                User.online === false && (m("div", { class: "alert alert--danger alert--icon" },
                    m("i", { class: "fas fa-exclamation-triangle" }),
                    m("span", null, "Sie haben zurzeit keine Verbindung zum Internet."))),
                m("div", { class: "login-intro" },
                    m(RouteLink, { href: linkTraveler, title: "Als Reisender anmelden", class: "login-intro__customer" }, "Ich bin ein Reisender"),
                    m(RouteLink, { href: linkAgency, title: "Als Reiseb\u00FCro anmelden", class: "login-intro__agency" }, "Ich bin ein Reiseb\u00FCro")),
                m("div", { class: "gettoknow-link" },
                    m(RouteLink, { id: "gettoknow-more", href: "/kennenlernen", title: "Mein Phoenix kennenlernen" }, "Mein Phoenix kennenlernen")),
            ];
        }
        catch (e) {
            logError(e);
            location.href = Config.urls.FE_ERROR;
        }
    },
};
export default View;
